/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { addValidator, required } from 'redux-form-validators';
import { Field, formValueSelector } from 'redux-form';
import FieldAnswerItem from '../FieldAnswerItem/FieldAnswerItem';

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  // change background colour if dragging
  // background: isDragging ? "lightgreen" : "grey",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const answerValidator = addValidator({
  validator: function (options, value, allValues) {
    if (value.text || value.url) {
      return true;
    }
    return {
      // id: 'form.errors.private_url',
      defaultMessage: options.msg || 'Заполните обязательно',
      // msg: options.msg,
    };
  },
});

function AnswerType3({ answers }) {
  const onDragEnd = () => {};
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {answers.map((item, index) => (
              <Draggable key={item._id} draggableId={item._id} index={index}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    style={getItemStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style
                    )}
                  >
                    <Field
                      key={'answer-' + index}
                      name={`answers[${index}]`}
                      placeholder="Введите текст ответа"
                      component={FieldAnswerItem}
                      validate={
                        index < 2
                          ? [
                              answerValidator({
                                msg: 'Заполните обязательно',
                              }),
                            ]
                          : []
                      }
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default AnswerType3;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/QuestionModal/components/components/Answers/components/AnswerType3/AnswerType3.jsx